export default function getBrowserLocale() {
  return navigator.languages
}
